/**
 * @deprecated Remove once crmDealLinking FeatureFlag is permanently enabled.
 */
import { useTranslation } from 'react-i18next';
import { useTopLevelObjectType } from 'pages/flex-data/flex-data-links/useTopLevelObjectType';
import SecondaryMenuTrigger from '../component/SecondaryMenuTrigger';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentId } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import { navigate } from 'utils/navigate';

interface LegacyIntegrationsButtonProps {
  documentId?: string;
}

export function LegacyIntegrationsButton({ documentId }: LegacyIntegrationsButtonProps) {
  const { t } = useTranslation();
  const contentId = useAppSelector(selectContentId);
  const { topLevelObjectTypes } = useTopLevelObjectType();

  const handleClick = () => {
    const noIntegrationsConnected = !topLevelObjectTypes.length;
    if (noIntegrationsConnected) {
      window.open('/integrations', '_blank');
    } else {
      const isV2 = !!documentId && /^\d+$/.test(documentId);
      const linkId = isV2 ? documentId : contentId;
      navigate(`/flex-data-links-v3/${linkId}?documentId=${documentId}`);
    }
  };

  return (
    <SecondaryMenuTrigger
      ButtonText={t('integrations.flex_data.flex_data_link_editor_button')}
      handleClick={handleClick}
      data-testid="document-settings-flex-data-link-button"
    />
  );
}
